import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import logo from "../assets/ss-loading-logo.png";
import {
	Grid,
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		paddingTop: "20%",
		[theme.breakpoints.down('md')]: {
			paddingTop: "30%",
		},
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},

	logo: {
		[theme.breakpoints.down('xs')]: {
			transform: "scale(0.75, 0.75)",
		}
	}
}));

function NoMatchAnonymous(props) {
	let classes = styles(),
		{updateHeader, resetHeader} = props;

	useEffect(() => {
		updateHeader({hideHeaderbar: true});
		return () => {
			resetHeader();
		};
	}, [updateHeader, resetHeader]);

	return (
		<div className={classes.root}>
			<Grid container direction="column" alignItems="center" spacing={2}>
				<Grid item>
					<img className={classes.logo} src={logo} alt="dark logo"/>
				</Grid>
			</Grid>
		</div>
	);
}

NoMatchAnonymous.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func
};

export default NoMatchAnonymous;

